import e from "react";
import m from "@appchoose/cn";
import N from "@appchoose/icon";
import { TooltipProvider as v, Tooltip as w, TooltipTrigger as T, TooltipContent as h, TooltipArrow as M } from "@appchoose/tooltip";
const j = (r, l, t = 0, o = 2) => new Intl.NumberFormat(l, {
  minimumFractionDigits: t,
  maximumFractionDigits: o
}).format(r), F = (r) => {
  const l = ["", "k", "M", "G", "T", "P", "E", "Z", "Y"], t = Math.floor(Math.log(r) / Math.log(1e3));
  return {
    value: r / Math.pow(1e3, t),
    symbol: l[t]
  };
}, R = ({
  icon: r,
  title: l,
  value: t,
  locale: o,
  appearance: a = "primary",
  tooltipContent: i,
  sign: n,
  showSign: x = !1,
  reverseSignAndValue: c = !1,
  className: p,
  maximumFractionDigits: b = 2,
  hasBorder: y = !0,
  additionalInfo: d,
  ...g
}) => {
  let f = t, s = null;
  x && (n ? s = n : { value: f, symbol: s } = F(t));
  const E = j(
    f,
    o,
    0,
    b
  ), u = /* @__PURE__ */ e.createElement("span", { className: "text-xs font-semibold uppercase tracking-wider text-gray-700" }, l);
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: m(
        "w-full space-y-4",
        {
          "border-beige-400 bg-beige-300": a === "secondary",
          "border-gray-300": a === "primary",
          "rounded border p-6": y
        },
        p
      ),
      ...g
    },
    /* @__PURE__ */ e.createElement("div", { className: "flex w-full items-center justify-between" }, /* @__PURE__ */ e.createElement("div", { className: "flex w-full items-center justify-between" }, /* @__PURE__ */ e.createElement("div", { className: "flex items-center gap-2.25" }, /* @__PURE__ */ e.createElement(N, { icon: r, size: "medium" }), i ? /* @__PURE__ */ e.createElement(v, null, /* @__PURE__ */ e.createElement(w, null, /* @__PURE__ */ e.createElement(T, { className: "border-b border-dashed border-gray-300 leading-none hover:border-solid" }, u), /* @__PURE__ */ e.createElement(h, { side: "top" }, i, /* @__PURE__ */ e.createElement(M, null)))) : u), d ? /* @__PURE__ */ e.createElement(
      "p",
      {
        className: m("text-xs capitalize", {
          "text-beige-600": a === "secondary",
          "text-gray-700": a === "primary"
        })
      },
      d
    ) : null)),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: m("flex space-x-1", {
          "flex-row-reverse justify-end space-x-reverse": c,
          "justify-start": !c
        })
      },
      /* @__PURE__ */ e.createElement("span", { className: "text-4xl font-bold text-gray-900" }, E),
      s ? /* @__PURE__ */ e.createElement("span", { className: "text-2xl font-bold text-gray-700" }, s) : null
    )
  );
};
R.displayName = "Statistics";
export {
  R as default
};
